//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'pop-filter-box',
  props: {
    isFixed: Boolean,   // 是否是固定定位
    manualShow: Boolean,  // 被动显示所有筛选条件
    dynamicCondition: Object, // 动态条件
  },
  data(){
    return {
      showAll: false,
      // recommand: 1,
      condition: {
        isCanCancel: '',    // 1 免费取消，0 不可免费取消，''全部
        isOfferMeal: '',    // 1 提供，0 不提供，'' 全部
        bedType: '',        // DOUBLE大床  TWIN双床  OTHER其他
      },
    };
  },
  watch: {
    manualShow(isShow){
      this.showAll = isShow;
    },

    dynamicCondition: {
      handler(newCondition){
        this.condition = newCondition;
      },
      deep: true,
    }
  },
  methods: {
    onClickCondition(){
      this.$emit('on-show-condition', this.isFixed);
    },

    onSetFilters(ev, filterType, immediately = false){
      const {filter} = ev.target.dataset;

      console.log(filter)
      if(filterType === 'meal'){
        this.condition.isOfferMeal = this.condition.isOfferMeal == filter ? '' : +filter;
        // this.$set(this.condition, 'isOfferMeal', +filter);
      }else if(filterType === 'bed'){
        this.condition.bedType = this.condition.bedType === filter ? '' : filter;
      }else{
        this.condition.isCanCancel = +this.condition.isCanCancel === 1 ? 0 : 1;
      }

      if(immediately) this.onConfirmFilter();
    },

    onResetCondition(){
      this.condition = {
        isCanCancel: '',    // 1 免费取消，0 不可免费取消，''全部
        isOfferMeal: '',    // 1 提供，0 不提供，'' 全部
        bedType: '',        // DOUBLE大床  TWIN双床  OTHER其他
      };
    },

    onConfirmFilter(){
      // this.showAll = !this.showAll;
      // console.log(this.condition);
      this.$emit('on-filter-room', this.condition);
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-detail/components/PopFilterBox.vue